<template>
  <div class="right-body" id="addEmails">
    <div class="all-drives">
      <div class="right-cont-middle">
        <div class="right-cont-middle-position">
          <span class="connect-desc">{{$t('language.addEmail.connectDesc')}}</span>
          <!-- <div class="icon order sort" :class="[rightBoShow?'':'order-click']" @click="cloudOrderSort"></div> -->
        </div>
      </div>
      <div class="right-cont-body">
        <div  :class="[rightBoShow?'cont-box':'cont-box-order']">
          <div class="drive-add-clouds-up" :class="{'up-clouds-none':!addEmailLine ||!addEmailLine.length}" v-if="rightBoShow" style="height: 100%">
            <div class="add-txt">{{$t('language.addEmail.peEmail')}}</div>
            <div class="drive-add-cloud-top">
              <div class="drive-add-cloud" :key="index" v-for="(item,index) in addEmailLine" @click="addEmailDialog(item)">
                <div class="add-cloud-item" v-if='item.appName'>
                  <div class='add-cloud-center'>
                    <div class="cloud cloud-size cloudPosition" :class="item.appName"></div>
                    <div class="add-cloud-item-name">{{$t('language.addCloud.'+item.appName)}}</div>
                    <div class="add-cloud-item-name add-cloud-item-name-coming" style="padding:0;"></div>
                  </div>
                </div>
              </div>
              <div>
                <div class="drive-add-cloud" :key="i" v-for="(item,i) in otherEmailLine">
                  <div class="add-cloud-item" v-if='item.appName'>
                    <div class='add-cloud-center'>
                      <div class="cloud cloud-size cloudPosition" :class="item.icon"></div>
                      <div class="add-cloud-item-name">{{item.appName}}</div>
                      <div class="add-cloud-item-name add-cloud-item-name-coming">{{$t('language.addCloud.comingSoon')}}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="selectInfo-footer">
          <div class="icon scaling-open scaling-open-position" v-show="snapTaskIconShow" @click="snapTasksOpen()">
            <snapTaskDialog ref="snapTaskDialog" @cancel='cancelUpload($event)'></snapTaskDialog>
          </div>
        </div>
      </div>
      <addCloudDialog ref="addCloudDialog"></addCloudDialog>
      <addFtpDialog ref="addFtpDialog"></addFtpDialog>
      <detailedProgrssDialog ref="detailedProgrss"></detailedProgrssDialog>
      <retryFailedDialog ref="retryFailedDialog"></retryFailedDialog>
      <cancelAllDialog ref="cancelAllDialog"></cancelAllDialog>
      <addNasDialog ref="addNasDialog"></addNasDialog>
      <addSpecialDialog ref="addSpecialDialog"></addSpecialDialog>
    </div>
  </div>
</template>

<script>
import commonstate from '@/js/constant.js';
import addCloudDialog from '@/components/popup/add_cloud_popups/add_cloud_popup';
import addFtpDialog from '@/components/popup/add_cloud_popups/add_ftp_popup';
import detailedProgrssDialog from '@/components/popup/cloud_exploer_popups/detailed_progress_popup';
import snapTaskDialog from "@/components/popup/cloud_exploer_popups/snap_task_popup";
import commonUtils from "@/js/workspace/common_util.js";
import retryFailedDialog from "@/components/popup/cloud_exploer_popups/retry_detailProgress_failed_popup";
import cancelAllDialog from '@/components/popup/cloud_exploer_popups/cancel_all_popup.vue';
import addNasDialog from '@/components/popup/add_cloud_popups/add_nas_popup';
import addCloudUtils from '@/js/workspace/add_cloud_utils.js';
import addSpecialDialog from '@/components/popup/add_cloud_popups/add_special_cloud_popup';
function sortDown (x, y) {
  return y.level - x.level;
}
export default {
  components: {
    addFtpDialog,
    addCloudDialog,
    snapTaskDialog,
    detailedProgrssDialog,
    retryFailedDialog,
    cancelAllDialog,
    addNasDialog,
    addSpecialDialog
  },
  inject: ["reload"],
  data: function () {
    return {
      rightBoShow: true,
      addEmailLine: [],
      emailClouds: commonstate.emailClouds,
      allCategories: [],
      allDrivesFlag: -1,
      drives: '',
      snapTaskIconShow: false,
      retryItems: [],
      reName:null,
      otherEmailLine: [{appName: "Office 365 Mail",icon:"officeMail"}],//之后再行添加的email集合
    };
  },
  mounted () {
    window.addEventListener('message', this.addCloudCallBack);
    this.groupCategories();
    //禁用拖拽功能
    commonUtils.dragDisAble('addClouds',this);
    //初始化临时任务数据
    commonUtils.mountedDetailData(this);
  },
  watch: {
    '$store.state.haveNewSnapData': function (newValue, oldValue) {
      let that = this;
      //触发事件后，判断是否获取进度
      if (this.$store.state.newDataFlag && this.$store.state.loadFlag) { //说明有新数据,并且没有数据在获取进度
        commonUtils.runDetailProgressData(that);
      }
    },
    //监听缓存中右侧待执行临时任务列表数据
    '$store.state.retryItems': function () {
      this.$refs.snapTaskDialog.items = Object.assign([], this.$store.state.retryItems);
      if (this.$store.state.retryItems.length > 200) {
        this.$store.state.retryItems.splice(201, this.$store.state.retryItems.length + 1);
        this.$toast({
          text: this.$t('language.cloudExploer.simultaneous'),
          type: 'fail',
          idValue: "rightBo"
        });
      }
      this.retryItems = this.$refs.snapTaskDialog.items;
    },
     //监听右侧待执行临时任务列表+上传列表总和数据
    retryItems: function (newValue, oldValue) {
      let that = this;
      if (!newValue.length) {
        this.$store.commit("setSourceItems", []);
        this.selectItemArr = [];
      }
      //任务执行列表执行操作，包括刷新后界面仍有任务
      if (oldValue.length == 0) {
        this.$nextTick(function () {
          if (that.$store.state.loadFlag) {
            commonUtils.runDetailProgressData(that);
            that.$store.state.loadFlag = false;
          }
        });
      }
    },
    //监听临时任务并根据状态将数据放在不同的tab页面
    '$store.state.detailedProgrssData': function (newValue, oldValue) {
      this.$refs.detailedProgrss.$refs.tab1.taskDatas = newValue;
    },
    //监听云盘数据，将其进行分类
    '$store.state.cloudCategories': function (newValue, oldValue) {
      if (newValue.length) {
        commonstate.cloudCategories = newValue;
        this.groupCategories();
        //this.getAllHeight();//监听如果有分类数据后给高度
      }
    },
     //监听上传列表数据
    '$store.state.uploadArr': function (newVale, oldValue) {
      let snapData = Object.assign([], this.$store.state.retryItems);
      let uploadArr = Object.assign([], this.$store.state.uploadArr);
      this.$refs.snapTaskDialog.items = snapData.concat(uploadArr);
    },
  },
  onDrag: function (e) {
    e.stopPropagation();
    e.preventDefault();
  },
  beforeRouteEnter (to, from, next) {
    if (from.name == 'login') {
      next((vm) => {
        let ud = commonUtils.getUser().id;
        vm.Utils.doDrivesRequest("list", {
          ud: ud
        }).then(result => {
            if (result.status == 200) {
              if (result.drives.length > 0) {
                vm.allDrivesFlag = true;
              } else {
                vm.allDrivesFlag = false;
              }
            } else {
              if(result.reason){
              vm.$toast({
                text: vm.$t('language.exception.' + result.reason),
                type: 'fail',
                idValue: "allBox"
              });
              }else{
                   vm.Utils.doDrivesRequest("list", {
                    ud: ud
                   }).then(result => {
                         if (result.status == 200) {
                         if (result.drives.length > 0) {
                             vm.allDrivesFlag = true;
                        } else {
                             vm.allDrivesFlag = false;
                        }
                      }
                   });
              }
            }
          })
      });
    } else {
      next((vm) => {
        vm.allDrivesFlag = true;
      });
    }
  },
  methods: {
    addCloudCallBack(result){
         let ud=commonUtils.getUser().id;
         var length= localStorage.getItem(ud+'driveNum');//用户的云盘列表长度
         if(length){
             localStorage.setItem(ud+'noticeShow',true);
         }
         // localStorage.removeItem(ud+'driveNum');
    },
    groupCategories () {
      let that = this;
      //获取云盘种类并存储在store中
      let addEmailLine = [];
      let CategoriesAll = commonstate.cloudCategories;
      let jsonTargetUp = [];
      let jsonTargetDown = [];
      for(var i=0;i<CategoriesAll.length;i++){
          var item = CategoriesAll[i];
          if(this.emailClouds.includes(item.appName)){
            addEmailLine.push(item);
          }
      }
      this.addEmailLine = addEmailLine;
      this.allCategories = addEmailLine;
      // this.$store.commit('setAddCloudLineUp', this.jsonTargetUp);
      // this.$store.commit('setAllCategories', this.addCloudLineUp.concat(this.addCloudLineDown));
    },
    snapTasksOpen () {//打开添加云盘的临时任务弹窗
      this.$store.state.snapTaskShow = !this.$store.state.snapTaskShow;
    },
    cloudOrderSort () {//切换到按字母排序
      this.rightBoShow = !this.rightBoShow;
    },
    //打开添加云盘弹窗
    addEmailDialog (item) {
      let that=this;
      let redirectUrl = commonstate.addCloudRedirectUrl;
      let user=commonUtils.getUser();
      let name=this.$t('language.addCloud.'+item.appName).trim().replace(/\s+/ig, " ");
      let allDrives = Object.assign([], this.$store.getters.getUsersDrives);
      let nameArr=[];
      $.each(allDrives, function (i, item) {
          nameArr.push(item.name);
      });
      commonUtils.includesDriveName(nameArr, name, that);
      let addData = new addCloudUtils.addCloudData(user.id, that.reName, null, null, null, null, null, null, item.appName, null, null, redirectUrl);
      //请求后端数据
      this.Utils.doDrivesRequest("add", addData).then(res => {
        if (res.status == 201) {//打开第三方网页
            var allDrives = Object.assign([], this.$store.getters.getUsersDrives);
            localStorage.setItem(user.id+'driveNum',allDrives.length);//用户的云盘列表长度
            that.Utils.openNewWin(res);
        }else{
            if(res.status == 401){
                this.$toast({
                          text: this.$t('language.exception.' + res.reason),
                          type: 'fail',
                          idValue: "addCloud"
                      });
            }
        }
      });
    },
    //打开界面重置添加云盘数据
    resetAddCloudData () {
      this.$refs.addCloudDialog.email = '';
      this.$refs.addCloudDialog.password = '';
      this.$refs.addCloudDialog.username = '';
      this.$refs.addCloudDialog.keyID = '';
      this.$refs.addCloudDialog.applicationKey = '';
      this.$refs.addCloudDialog.bucketName = '';
      this.$refs.addCloudDialog.otherServerHttp = '';
    },//添加云盘界面的取消上传
    cancelUpload: function (data) {
      let that = this;
      if (commonstate.source) {
        commonstate.source.cancel('取消上传' + data);
      }
    },
  },
  computed: {
    //用于对云盘按英文字母进行排序
    reorder: function () {
      return this.allCategories.sort(function (x, y) {
        return x["appName"].localeCompare(y["appName"]);
      });
    },

  }
};
</script>

<style scoped>
@charset "utf-8";
.add-cloud-center{
    display: table-cell;
    vertical-align: middle;
}
.all-drives {
  width: 100%;
  height: 100%;
}
.add-txt{
    position: absolute;
    font-weight:bold;
    top: 15Px;
    left: 15Px;
}
.slide {
  position: relative;
  left: 3px;
  /*no*/
  top: 2px;
  /*no*/
}

.right-cont-middle {
  height: 80px;
  /*no*/
  width: 96%;
  float: left;
  background-color: #f2f7fe;
  padding: 0% 2% 0% 2%;
  position: relative;
}

.right-cont-middle-position {
  height: 20px;
  /*no*/
  width: 96%;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
}

.select-box-click {
  border: 1px solid #8a96e3;
  /*no*/
}

.connect-desc {
  float: left;
  font-size: 20px;
  /*no*/
}

.cont-box {
  width: 96%;
  height: 96%;
  margin: 0% 2% 0% 2%;
  box-sizing: border-box;
  overflow: hidden;

}

.cont-box-order{
  width: 96%;
  height: 96%;
  margin: 0% 2% 0% 2%;
  box-sizing: border-box;
  overflow: hidden;
  background: #fff;
  padding:2%;
  border: 1Px solid #e4e9f3;
}

.drive-add-clouds-order {
  width: 100%;
  height: 47.5%;
  text-align: center;
}

.up-clouds-none {
  border: none !important;
}

.sort {
  float: right;
  cursor: pointer;
}

/*云盘添加列表界面*/
.drive-add-cloud {
  width: 10%;
  float: left;
  color: rgba(0, 0, 0, 0.6);
  height: 140Px;/*no*/
  margin: 0 1%;
  border-radius: 4px;/*no*/
}

.drive-add-cloud:hover {
  box-shadow: 1px 1px 5px 1px #bababa;
}

.widthNav2 #addEmails .drive-add-cloud {
    width: 15%;
}

.drive-add-cloud-order {
  width: 12%;
  float: left;
  color: rgba(0, 0, 0, 0.6);
  height: 105Px;

}

.drive-add-cloud-order:hover {
  box-shadow: 1px 1px 5px 1px #bababa;
  /*no*/
}

.add-cloud-item-name {
  width: 100%;
  height: 20%;
  font-size: 14px;
  /*no*/
  float: none !important;
  text-align: center;
  margin-top: 5Px;
  font-family: Roboto Medium;
}

.cloudPosition {
  position: relative;
  top: 5px;
  /*no*/
}

.select-mode-value {
  width: 178px;
  /*no*/
  height: 68px;
  /*no*/
  position: absolute;
  z-index: 1;
  font-size: 14px;
  /*no*/
  color: rgba(0, 0, 0, 0.6);
  border: 1px solid #8a96e3;
  /*no*/
  border-top: none;
  background: #fff;
  left: 130px;
  /*no*/
  top: 44px;
  /*no*/
}

.select-cod-value {
  width: 178px;
  /*no*/
  height: 170px;
  /*no*/
  position: absolute;
  z-index: 1;
  font-size: 14px;
  /*no*/
  color: rgba(0, 0, 0, 0.6);
  border: 1px solid #8a96e3;
  /*no*/
  border-top: none;
  background: #fff;
  left: 130px;
  /*no*/
  top: 44px;
  /*no*/
}

.add-cloud-item-name-coming {
    background: #E4E7F3;
    border-radius: 9px;/*no*/
    width: fit-content !important;
    padding: 0 10px;/*no*/
    line-height: 20px;/*no*/
    height: 20px;/*no*/
    font-size: 14px;
    /*no*/
    text-align: center;
    margin: auto;
    margin-top: 5Px;
    float: none !important;
}

.btn-brd-gry {
    border: 1px solid #ccc;/*no*/
    border-radius: 10px;/*no*/
    height: 34px;/*no*/
    line-height: 34px;/*no*/
    background: 0 0;
    color: #000;
    font-size: 14px!important;/*no*/
    font-family: Roboto-Regular,Roboto;
    font-weight: 400;
    padding: 0 8px;/*no*/
}

.btn-brd-gry:hover {
    box-shadow: 0px 2px 8px rgba(62,70,120,0.46);
}

.google-small {
    width: 18px;/*no*/
    height: 18px;/*no*/
    margin-right: 10px;/*no*/
    background: url("https://www.multcloud.com/assets/images/sign/MC-signup-ic-log-google-small.svg") no-repeat;
    display: inline-block;
    vertical-align: middle;
    margin-left: 0;
}

.gmail-88 {
  width: 60px !important;/*no*/
  height: 45px !important;/*no*/
  background: url("../../assets/images/vectorImg/icon-gmail-88.svg") no-repeat !important;
  margin-bottom: 10px;/*no*/
}

.drive-add-cloud-top {
  padding-bottom: 0px;
  padding-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/workspace/add_email.vue